import React, { Fragment, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import styles from './index.pcss';
import { getProperty } from '../../../modules/ajio-util/properties';
import Dialog from '../../../refresh/molecules/Dialog';
import Modal from '../../../components/common/Modal';
import { showModal } from '../../../actions/modal';
import FreebiesGiftCard from './FreebiesGiftCard';
import { getFreebiesText } from './FreebiesCommon';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import { getGiftWithProductEnable, getGiftWithProductConfig } from '../../../refresh/selectors/featureFlagsSelector';

const cx = classNames.bind(styles);

const iconStyle = {
    margin: "2px 3px",
};

const fallbackImg = `${getProperty('imageBaseUrl')}/static/img/freebie-gift.svg`;
const fallbackImgLuxe = `${getProperty('imageBaseUrl')}/static/img/freebie-gift-luxe.svg`;

const Freebies = (props) => {
    const [showDialog, setShowDialog] = useState(false);
    const {
      giftItemsList =[],
      totalGiftCount = 0,
      giftWithProductConfig: { pdpFreebieTitle ='', pdpHalfCardFreebieTitle=''}= {}, 
      isDesktop=false, 
      enableGiftWithProductFlag=false, 
      showModal,
      isLuxe=false
     } = props;

    const viewGiftHandler = () => {
      gtmEventPush({
        event: 'product_details_interactions',
        event_category: 'product details interactions',
        event_action: 'Freebies click',
        event_label: totalGiftCount,
        page_type: 'pdp screen'
      });

      if(isDesktop){
        return showModal('freebies-modal');
      }
      setShowDialog(true); 
    };

    useEffect(() => {
      if (showDialog) {
        gtmEventPush({
            event: 'pageload',
            page_type: 'Promotion offer screen',
            page_name: 'Promotion offer screen'
        });
      }
    }, [showDialog]);

    if(Object.keys(giftItemsList).length === 0 || !enableGiftWithProductFlag) {
      return <></>
    }

    return (
        <Fragment>
            <div className={cx(isDesktop ? (isLuxe ? "freebies-container-desktop-luxe" : "freebies-container-desktop") : (!isLuxe ? "freebies-container" : "freebies-container-luxe"))} onClick={viewGiftHandler} tabIndex={0} role='button' aria-haspopup='dialog'>
                <div><span aria-hidden={true}>+</span>{" "}{getFreebiesText(pdpFreebieTitle, totalGiftCount)}</div>
                <div className={cx("freebies-product-icons", `${isLuxe && "luxe-color-bg"}`)}>
                <img
                    src={!isLuxe ? fallbackImg: fallbackImgLuxe}
                    alt="freebie-gift-image"
                    height={"20px"}
                    width={"20px"}
                    aria-hidden='true'
                />
                <img
                    src={`${getProperty('imageBaseUrl')}/static/img/freebie-vector${isLuxe ? '-luxe': ''}.svg`}
                    alt="freebie-forward-icon"
                    style={iconStyle}
                    height={"20px"}
                    width={"20px"}
                    aria-hidden='true'
                />
                </div>
            </div>
            {!isDesktop ? <Dialog
              showDialog={showDialog}
              type={"drawer"}
              onCancel={()=>setShowDialog(false)}
              customClass={cx('return-dialog')}
              ariaLabel='Freebies Gift Card'
            >
                <FreebiesGiftCard
                    giftItemsList={giftItemsList}
                    halfCardFreebiesTitle={pdpHalfCardFreebieTitle}
                    isDesktop={isDesktop}
                    isLuxe={isLuxe}
                />
            </Dialog> :

            <Modal
              name="freebies-modal"
              closeButton
              onClose={()=>setShowDialog(false)}
              alignToRight
              fullHeight
            >
                  <FreebiesGiftCard
                    giftItemsList={giftItemsList}
                    halfCardFreebiesTitle={pdpHalfCardFreebieTitle}
                    isDesktop={isDesktop}
                    isLuxe={isLuxe}
                  />
            </Modal>}

        </Fragment>
    )
};

const mapDispatchToProps = (dispatch) => {
    return {
      showModal: (name, config) => {
        dispatch(showModal(name, config));
      },
    }
};

const mapStateToProps = (state) => {
    const { flags = {} } = state;
    const isLuxe = getCurrentStore(state) === 'luxe';

    const enableGiftWithProductFlag = getGiftWithProductEnable(flags);
    const giftWithProductConfig = getGiftWithProductConfig(state);

    return {
        giftWithProductConfig,
        enableGiftWithProductFlag,
        isLuxe
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Freebies);
